import { CommonPageWrapper, HeadingWrapper } from 'admin/components/wrappers';
import AdminCustomButton from 'app/components/AdminCustomButton';
import { AdminSearch } from 'app/components/AdminSearchField';
import CustomBreadCrumb from 'app/components/CustomBreadCrumb';
import { BlurredLabel, PageMainLabel } from 'app/components/SHLabel';
import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import { useDebounce } from 'hooks/useDebounce';
import useCommonLookUpDatas from 'hooks/useCommonLookupData';
import { getLookupArray, useNavigateToRoute } from 'utils/common';
import CoachesTable from './CoachesTable';
import useCoachApi from 'admin/hooks/useCoachApi';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import { defaultCoachValue } from '../CoachIndividualPage/components/coachCreateEditPage/staticDatas';
import { Coach, GeneralLookup } from 'services/openapi';
import AdminDropDown from 'app/components/AdminDropDown';
import AdminMultiSelectDropDown from 'admin/components/AdminMultiSelectDropdown';
import { ShowMangeRiderFilteredData } from 'admin/components/AdminMultiSelectDropdown/FilteredList';
import { CommonLoader } from 'app/components/CommonLoader';
import { usePermission } from 'hooks/usePermission';

const CoachesPage = () => {
  const { status } = useParams();
  const currentLocation = useLocation();
  const { hasViewPermission } = usePermission();
  const isPastDataFlag = currentLocation.pathname.includes('past-data');
  const breadCrumpitems = [
    {
      id: '',
      text: 'Showyeda admin',
      disabled: true,
    },
    {
      id: '',
      text: 'Coaches',
      disabled: true,
    },
  ];
  const {
    fetchManageGetCoaches,
    coachProfileData,
    loading,
    CoachActiveOrInactive,
    deleteCoachList,
    downloadLoading,
    handleDownloadCoach,
  } = useCoachApi();
  const navigate = useNavigate();
  const redirect = useNavigateToRoute();
  const { id: coachId } = useParams();
  const [paidFilter, setPaidFilter] = useState<number | null>(null);
  const { getAllLookupData, lookUps } = useCommonLookUpDatas();
  // Initialize selectedItemId based on URL status parameter
  const getInitialSelectedItemId = () => {
    if (status === 'active') {
      return 'bc1e49f9-0f4a-4222-ba22-c4f4af0b4f75';
    } else if (status === 'inactive') {
      return 'f7f4cf58-a6fd-4646-9e25-d9517f92709e';
    }
    // No status param means show both (no filter)
    return null;
  };

  const [selectedItemId, setSelectedItemId] = useState<string | null>(getInitialSelectedItemId());
  const [active, setActive] = useState(true);
  const [searchTerm, setSearchTerm] = useState<string>('');
  const [pageSkip, setPageSkip] = useState<number | undefined>(0);
  const debounceCoachSearch = useDebounce(searchTerm);
  const handleItemIdClick = (itemId: string) => {
    const newSelectedItemId = itemId === selectedItemId ? null : itemId;
    setSelectedItemId(newSelectedItemId);

    if (newSelectedItemId) {
      // A filter is selected
      let statusRoute = '';
      if (itemId === 'bc1e49f9-0f4a-4222-ba22-c4f4af0b4f75') {
        statusRoute = 'active';
      } else if (itemId === 'f7f4cf58-a6fd-4646-9e25-d9517f92709e') {
        statusRoute = 'inactive';
      }

      if (statusRoute) {
        const fullPath = isPastDataFlag
          ? `/admin/past-data/coaches/${statusRoute}`
          : `/admin/coaches/${statusRoute}`;
        navigate(fullPath, { replace: true });
      }
    } else {
      // No filter selected (deselected) - navigate to base path (shows both)
      const fullPath = isPastDataFlag
        ? `/admin/past-data/coaches`
        : `/admin/coaches`;
      navigate(fullPath, { replace: true });
    }
    fetchManageGetCoaches(
      '',
      teamId,
      debounceCoachSearch,
      newSelectedItemId ?? '',
      sortField,
      sortOrder,
      0,
      pageSize,
      paidFilter as number,
    );
  };
  const [coachPayload, setCoachPayload] =
    React.useState<Coach>(defaultCoachValue);
  const [sortField, setSortField] = useState<string>('coachName');
  const [sortOrder, setSortOrder] = useState<number>(0);
  const [pageSize, setPageSize] = useState<number>(50);
  const [pageSizeSelected, setPageSizeSelected] = useState<GeneralLookup>({
    id: '50',
    name: '50',
  });

  // Page size options for the dropdown
  const pageSizeOptions: GeneralLookup[] = [
    { id: '25', name: '25' },
    { id: '50', name: '50' },
    { id: '100', name: '100' },
    { id: '200', name: '200' },
  ];
  const [lookupData, setLookupData] = useState('');
  const [teamIds, setTeamIds] = useState('');
  const [preDataList, setPreDataList] =
    useState<{ name: string; id: string; type: string }[]>();
  const isTeam = preDataList?.find(item => item.type === 'TEAM');
  const teamIdsArray = teamIds ? teamIds.split(',') : [];
  const teamId = isTeam ? teamIdsArray : [];
  const [seasonPayload, setSeasonPayload] = React.useState<GeneralLookup>({
    id: '',
    name: '',
  });
  const handleDropdownChange = (data: GeneralLookup, name: string) => {
    setSeasonPayload(data);
    fetchManageGetCoaches(
      data.id,
      teamId,
      debounceCoachSearch,
      selectedItemId ?? '',
      sortField,
      sortOrder,
      0,
      pageSize,
      paidFilter as number,
    );
    setCoachPayload(prevData => ({
      ...prevData,
      [name]: data,
    }));
  };
  const handleSearch = e => {
    setSearchTerm(e.target.value);
  };
  const handleCoachDwoload = async () => {
    try {
      const url: any = await handleDownloadCoach(
        seasonPayload.id,
        teamId,
        debounceCoachSearch,
        selectedItemId ?? '',
        sortField,
        sortOrder,
        paidFilter as number,
      );

      // Extract filename from URL
      const filename = url.split('/').pop();

      fetch(url)
        .then(response => response.blob())
        .then(blob => {
          const objectUrl = URL.createObjectURL(blob);

          const link = document.createElement('a');
          link.href = objectUrl;
          link.download = filename!; // Use the extracted filename

          // Append link to body (required for Firefox)
          document.body.appendChild(link);

          // Trigger download
          link.click();

          // Clean up
          document.body.removeChild(link);
          URL.revokeObjectURL(objectUrl);
        })
        .catch(error => {
          console.error('Error downloading file:', error);
        });

      return url;
    } catch (error) {
      console.error('Error downloading team point report:', error);
      throw error;
    }
  };
  useEffect(() => {
    if (debounceCoachSearch.length > 0) {
      fetchManageGetCoaches(
        '',
        teamId,
        debounceCoachSearch,
        selectedItemId ?? '',
        sortField,
        sortOrder,
        0,
        pageSize,
        paidFilter as number,
      );
    } else if (status) {
      // Use URL status parameter if provided
      const activeStatusId =
        status === 'active'
          ? 'bc1e49f9-0f4a-4222-ba22-c4f4af0b4f75'
          : 'f7f4cf58-a6fd-4646-9e25-d9517f92709e';
      setSelectedItemId(activeStatusId);
      fetchManageGetCoaches(
        '',
        teamId,
        debounceCoachSearch,
        activeStatusId,
        sortField,
        sortOrder,
        0,
        pageSize,
        paidFilter as number,
      );
    } else {
      // Default to Active status when no status param
      fetchManageGetCoaches(
        '',
        teamId,
        debounceCoachSearch,
        selectedItemId ?? '',
        sortField,
        sortOrder,
        0,
        pageSize,
        paidFilter as number,
      );
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [debounceCoachSearch, status]);

  // Effect to trigger fetch when team filter IDs change
  useEffect(() => {
    setPageSkip(0);
    fetchManageGetCoaches(
      '',
      teamId,
      debounceCoachSearch,
      selectedItemId ?? '',
      sortField,
      sortOrder,
      0,
      pageSize,
      paidFilter as number,
    );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [teamIds]);

  useEffect(() => {
    getAllLookupData('ACTIVESTATUS,SEASON,TEAM');
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return (
    <>
      <CommonPageWrapper>
        {downloadLoading && <CommonLoader loaderType="main" />}
        <HeadingWrapper>
          <PageMainLabel>Coaches</PageMainLabel>
          <CustomBreadCrumb preData={breadCrumpitems} />
        </HeadingWrapper>
        <HeadingWrapper>
          <ButtonWrapper>
            {hasViewPermission('0400101002') && (
              <>
                {!isPastDataFlag && (
                  <AdminCustomButton
                    buttonType="primary"
                    isActive={false}
                    className="fill-button"
                    onClick={() => {
                      setActive(!active);
                      if (!coachId) {
                        redirect(`/admin/coaches/add/create`);
                      }
                    }}
                  >
                    Add New Coach
                  </AdminCustomButton>
                )}
              </>
            )}

            <BlurredLabel style={{ whiteSpace: 'nowrap' }}>
              Popular filter
            </BlurredLabel>
            {/* <AdminCustomButton
              buttonType="primary"
              isActive={paidFilter === 1}
              className={
                paidFilter === 1 ? 'active-inactive' : 'Inactive-button'
              }
              onClick={() => {
                setPaidFilter(paidFilter === 1 ? null : 1);
                fetchManageGetCoaches(
                  '',
                  teamId,
                  debounceCoachSearch,
                  selectedItemId ?? '',
                  sortField,
                  sortOrder,
                  0,
                  pageSize,
                  paidFilter === 1 ? undefined : 1,
                );
              }}
            >
              Paid
            </AdminCustomButton>
            <AdminCustomButton
              buttonType="primary"
              isActive={paidFilter === 2}
              className={
                paidFilter === 2 ? 'active-inactive' : 'Inactive-button'
              }
              onClick={() => {
                setPaidFilter(paidFilter === 2 ? null : 2);
                fetchManageGetCoaches(
                  '',
                  teamId,
                  debounceCoachSearch,
                  selectedItemId ?? '',
                  sortField,
                  sortOrder,
                  0,
                  pageSize,
                  paidFilter === 2 ? undefined : 2,
                );
              }}
            >
              Unpaid
            </AdminCustomButton> */}
            {getLookupArray('ACTIVESTATUS', lookUps).map(item => (
              <AdminCustomButton
                key={item.id}
                buttonType="primary"
                isActive={false}
                className={
                  selectedItemId?.includes(item?.id)
                    ? 'active-inactive'
                    : 'Inactive-button'
                }
                onClick={() => {
                  handleItemIdClick(item?.id);
                }}
              >
                {item?.name}
              </AdminCustomButton>
            ))}
            <AdminMultiSelectDropDown
              data={ShowMangeRiderFilteredData}
              setLookupData={setLookupData}
              filteredData={getLookupArray(lookupData, lookUps)}
              lookUps={lookUps}
              setTeamIds={setTeamIds}
              lookupData={lookupData}
              setPreDataList={setPreDataList}
              preDataList={preDataList}
            />
            {isPastDataFlag && (
              <CustomDropDown
                label=""
                placeholder="Select season"
                onDataChange={data => handleDropdownChange(data, 'season')}
                defaultValue={coachPayload.season}
                data={getLookupArray('SEASON', lookUps)}
                className="field-style filter-dropdown-select"
                popupStyles="medium-dropdown"
              />
            )}
          </ButtonWrapper>
          <div className="search-wrapper">
            {/* {!isPastDataFlag && ( */}
            <AdminCustomButton
              buttonType="primary"
              isActive={false}
              className="fill-button"
              onClick={handleCoachDwoload}
              disabled={coachProfileData?.coaches?.length === 0}
            >
              Download
            </AdminCustomButton>
            {/* )} */}

            <div style={{ width: '283px', paddingTop: '30px' }}>
              <AdminSearch
                placeholder="Search by name"
                onSearchTextEntering={handleSearch}
                searchTerm={searchTerm}
                setSearchTerm={setSearchTerm}
              />
            </div>
          </div>
        </HeadingWrapper>
        {(coachProfileData?.pageDetails?.count ?? 0) > 10 && (
          <EntriesPerPageDropDownWrapper>
            <AdminDropDown
              label="No: of entries per page"
              placeholder="Select entries"
              onDataChange={(data: GeneralLookup) => {
                const newPageSize = parseInt(data.id, 10);
                setPageSize(newPageSize);
                setPageSizeSelected(data);
                setPageSkip(0);
                fetchManageGetCoaches(
                  '',
                  teamId,
                  debounceCoachSearch,
                  selectedItemId ?? '',
                  sortField,
                  sortOrder,
                  0,
                  newPageSize,
                  paidFilter as number,
                );
              }}
              defaultValue={pageSizeSelected}
              data={pageSizeOptions}
              className="entries-dropdown-style"
              popupStyles="entries-dropdown-popup"
            />
          </EntriesPerPageDropDownWrapper>
        )}
        {/* Coaches Table */}
        {hasViewPermission('0400101001') && (
          <CoachesTable
            setPageSkip={setPageSkip}
            pageSkip={pageSkip}
            debounceCoachSearch={debounceCoachSearch}
            selectedItemId={selectedItemId}
            lookup={getLookupArray('ACTIVESTATUS', lookUps)}
            fetchManageGetCoaches={fetchManageGetCoaches}
            coachProfileData={coachProfileData}
            deleteCoachList={deleteCoachList}
            CoachActiveOrInactive={CoachActiveOrInactive}
            sortField={sortField}
            sortOrder={sortOrder}
            setSortField={setSortField}
            setSortOrder={setSortOrder}
            loading={loading}
            teamId={teamId}
            paidFilter={paidFilter}
            pageSize={pageSize}
            pageSizeSelected={pageSizeSelected}
          />
        )}
      </CommonPageWrapper>
    </>
  );
};
export default CoachesPage;

const ButtonWrapper = styled.div`
  display: flex;
  gap: 10px;
  padding: 30px 0 0;
  .field-style {
    display: flex;
  }
`;
const CustomDropDown = styled(AdminDropDown)`
  width: 160px;
  .k-dropdownlist {
    max-height: 31px;
    border-radius: 6px !important;
  }
  .k-input-inner {
    padding: 0 5px !important;
  }
  .k-input-value-text {
    margin: 2px 4px 2px 4px;
    font-size: 12px !important;
    letter-spacing: 0px;
    color: #1e1e1e;
    text-align: left;
  }
`;
const EntriesPerPageDropDownWrapper = styled.div`
  display: flex;
  align-items: flex-start;
  padding-top: 10px;

  .SHdropdown {
    width: 160px;

    .label {
      margin-bottom: 8px;
      font-size: 13px;
      color: #475467;
      font-weight: 500;
    }

    .k-dropdownlist {
      max-height: 38px;
      border-radius: 8px !important;
    }

    .k-input-inner {
      padding: 0 8px !important;
      font-size: 13px;
    }

    .k-input-value-text {
      margin: 4px 0;
      font-size: 13px !important;
      color: #1e1e1e;
    }
  }
`;
